






















import Vue from "vue";

export default Vue.extend({
  name: "HealthLoadingState",
  props: { authorizationFlowPending: { type: Boolean, default: false } }
});
